import React from 'react'
import PropTypes from 'prop-types'
import { get, sortBy, isEmpty, compact, uniqBy } from 'lodash'
import classNames from 'classnames'

import { ReactComponent as CheckBoxEmpty } from '../../assets/icons/checkBoxEmpty.svg'
import { ReactComponent as CheckBoxSelected } from '../../assets/icons/checkBoxSelected.svg'
import { ReactComponent as SelectedVectorIcon } from '../../assets/icons/selected-vector.svg'
import { roleInfo } from '../../utils/employeeRoles'

const SuiteRow = ({
  disabled,
  employeeRoles,
  eventId,
  history,
  preOrders,
  selectedSuites,
  setSelectedSuites,
  suite,
  setEventDetailsScrollPosition,
}) => {
  const customerAndAttendantInfo = {
    customers: {
      items: sortBy(get(suite, 'customers', []), 'customerName'),
      id: 'customerId',
      name: 'customerName',
      redirect: `/events/${eventId}/${suite.rvcUuid}/`,
    },
    attendants: {
      items: sortBy(uniqBy(get(suite, 'attendants', []), 'employeeId'), 'attendantName'),
      id: 'attendantUuid',
      name: 'attendantName',
      redirect: `/suites/menus/${eventId}/`,
    }
  }

  const sortedListAssignedWithSuiteAttendantsBeforeCartAttendants = (array) => {
    return array.map((item) => {
      const legacyRole = employeeRoles?.[item?.employeeId]?.role
      const newRole = isEmpty(legacyRole) ? employeeRoles?.[item?.roleId]?.role : legacyRole
      const role = roleInfo?.[newRole]?.name

      return {
        ...Object.assign(item, {role})
      }
    })
    .sort((cart, suite) => {
      return suite.role?.localeCompare(cart.role)
    })
  }

  const displayAssignedCustomersOrAttendants = (suiteUsersType) => {
    const customersRowInfo = customerAndAttendantInfo[suiteUsersType]
    const { items, id, name, redirect } = customersRowInfo
    const sortedAttendants = suiteUsersType === 'attendants' ?
      sortedListAssignedWithSuiteAttendantsBeforeCartAttendants(items) : items

    const preOrdersWithPreOrderType = preOrders.filter(preOrder => preOrder.orderType === 'preorder')

    const result = sortedAttendants.map((item, index) => {
      const legacyEmployeeRole = get(employeeRoles, item?.employeeId)
      const employeeRole = isEmpty(legacyEmployeeRole) ? get(employeeRoles, item?.roleId) : legacyEmployeeRole
      const role = roleInfo?.[employeeRole?.role]

      const preOrdersPerCustomerAndPerStands = suiteUsersType === 'customers' ? preOrdersWithPreOrderType.filter(
        preOrderWithPreOrderType => preOrderWithPreOrderType.customerId === item.customerId
          && preOrderWithPreOrderType.standUuid === suite.rvcUuid
      ) : []

      if (suiteUsersType === 'attendants' && item[id] && role?.name !== 'Cart Attendant' && role?.name !== 'Suite Attendant') {
        return null
      }

      return (
        <div
          className="suite-assignment"
          key={index}
          onClick={() => {
            if (item[id]) {
              history.push(`${redirect}${item[id]}`)
              setEventDetailsScrollPosition()
            }
          }}>
          {(suiteUsersType === 'customers' && !isEmpty(preOrdersPerCustomerAndPerStands)) && (
            <span className="suite-assignment__customer-preorders-number">{preOrdersPerCustomerAndPerStands.length}</span>
          )}
          <span className="suite-assignment__item-text">
            {item[id] ? item[name] : "Anonymous"}
          </span>
          {!isEmpty(employeeRole) &&
            <span className="suite-role" style={{ backgroundColor: role?.color }}>
              {role?.abbreviation}
            </span>
          }
        </div>
      )
    })

    if (isEmpty(result)) return '–'

    return compact(result)
  }

  const selectSuite = () => {
    if (disabled) return

    if (selectedSuites[suite.rvcUuid]) {
      delete selectedSuites[suite.rvcUuid]
      setSelectedSuites({ ...selectedSuites })
    } else {
      setSelectedSuites({ ...selectedSuites, [suite.rvcUuid]: suite.rvcName })
    }
  }

  let checkbox = null

  if (selectedSuites[suite.rvcUuid]) {
    checkbox = (
      <div className="checkbox-container" onClick={selectSuite}>
        <CheckBoxSelected />
        <SelectedVectorIcon className='vector-icon'/>
      </div>
    )
  } else {
    checkbox = (
      <div className="checkbox-container" onClick={selectSuite}>
        <CheckBoxEmpty />
      </div>
    )
  }

  if (disabled) {
    checkbox = null
  }

  const eventDetailsClasses = classNames('event-details__suites-row', {
    '-selected': selectedSuites[suite.rvcUuid]
  })

  return (
    <div className={eventDetailsClasses}>
      <div className='left-side'>
        {checkbox}
        <span className='suite-stand'>{suite.rvcName}</span>
      </div>
      <span className='suite-customers-assignments'>
        {displayAssignedCustomersOrAttendants('customers')}
      </span>
      <span className='suite-attendants-assignments'>
        {displayAssignedCustomersOrAttendants('attendants')}
      </span>
    </div>
  )
}

SuiteRow.defaultProps = {
  disabled: false,
  eventId: '',
  suite: {},
}

SuiteRow.propTypes = {
  disabled: PropTypes.bool,
  eventId: PropTypes.string,
  preOrders: PropTypes.array,
  suite: PropTypes.object,
}

export default SuiteRow
